// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Modern Beautiful Design for User Information Dashboard */

/* Import Google Fonts for better typography */

/* CSS Variables - Qatar theme (1f7c50, 07ffa9, 101413, accbc3) */
:root {
  --primary-color: #accbc3;
  --primary-light: #e5f6f2;
  --primary-dark: #7b9f96;
  --secondary-color: #1f7c50;
  --accent-color: #07ffa9;
  --success-color: #07ffa9;
  --warning-color: #1f7c50;
  --error-color: #ef4444;
  --text-primary: #1e293b;
  --text-secondary: #475569;
  --text-muted: #64748b;
  --icon-color: #64748b;
  --bg-primary: #ffffff;
  --bg-secondary: #f8fafc;
  --bg-tertiary: #f1f5f9;
  --border-color: #e2e8f0;
  --border-light: #f1f5f9;
  --shadow-sm: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  --shadow-md: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  --shadow-lg: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  --shadow-xl: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  --gradient-primary: linear-gradient(135deg, rgba(7, 255, 169, 0.15) 0%, rgba(31, 124, 80, 0.2) 100%);
  --gradient-secondary: linear-gradient(135deg, #07ffa9 0%, #1f7c50 100%);
  --gradient-success: linear-gradient(135deg, #07ffa9 0%, #1f7c50 100%);
  --gradient-warning: linear-gradient(135deg, #1f7c50 0%, #1a6b45 100%);
  --btn-submit-bg: #1f7c50;
  --btn-submit-hover: #1a6b45;
}

/* Global Styles */
* {
  box-sizing: border-box;
}

body {
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  line-height: 1.6;
  color: var(--text-primary);
  background: linear-gradient(135deg, #e2e8f0 0%, #cbd5e1 100%);
  min-height: 100vh;
  margin: 0;
  padding: 0;
}

.root {
  margin-top: 130px;
  padding: 0.5rem;
  width: 100%;
  max-width: 100%;
  margin-left: 0;
  margin-right: 0;
}

/* Dashboard Header */
.dashboard-header {
  background: var(--bg-primary);
  border-radius: 12px;
  padding: 1.25rem;
  margin-bottom: 1rem;
  box-shadow: var(--shadow-md);
  border: 1px solid var(--border-light);
  position: relative;
  overflow: hidden;
  width: 100%;
}

.dashboard-header::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 2px;
  background: linear-gradient(90deg, #07ffa9, #1f7c50);
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.75rem;
  width: 100%;
}

.dashboard-title {
  color: #1f7c50;
  font-size: 1.5rem;
  font-weight: 700;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.title-icon {
  font-size: 1.75rem;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));
}

.tab-navigation {
  display: flex;
  gap: 0.25rem;
  background: var(--bg-secondary);
  padding: 0.375rem;
  border-radius: 10px;
  box-shadow: var(--shadow-sm);
}

.tab-button {
  padding: 0.625rem 1.25rem;
  border: none;
  background: transparent;
  color: var(--text-secondary);
  font-weight: 500;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 0.8rem;
}

.tab-button:hover {
  color: var(--text-primary);
  background: var(--bg-tertiary);
}

.tab-button.active {
  background: var(--btn-submit-bg);
  color: white;
  box-shadow: 0 2px 8px rgba(31, 124, 80, 0.35);
}

/* Beautiful Card Design */
.info-card {
  background: var(--bg-primary);
  border-radius: 12px;
  padding: 1.25rem;
  margin-bottom: 1rem;
  box-shadow: var(--shadow-md);
  border: 1px solid var(--border-light);
  position: relative;
  overflow: hidden;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  width: 100%;
}

.info-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 2px;
  background: var(--gradient-secondary);
}

.info-card:hover {
  transform: translateY(-1px);
  box-shadow: 0 15px 30px -10px rgba(0, 0, 0, 0.1);
}

/* Section Titles with Beautiful Design - Qatar */
.section-title {
  color: #1f7c50;
  font-size: 1.5rem;
  font-weight: 600;
  margin-bottom: 1rem;
  display: flex;
  align-items: center;
  gap: 0.625rem;
  position: relative;
  padding-bottom: 0.5rem;
}

.section-title::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 40px;
  height: 2px;
  background: #1f7c50;
  border-radius: 1px;
}

.section-icon {
  font-size: 1.25rem;
  color: var(--icon-color);
  filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.1));
}

/* Count badges */
.framework-count,
.services-count {
  background: var(--bg-secondary);
  color: var(--text-secondary);
  padding: 0.125rem 0.5rem;
  border-radius: 8px;
  font-size: 0.7rem;
  font-weight: 600;
  margin-left: 0.375rem;
  border: 1px solid var(--border-light);
}

/* Organization Name */
.org-name {
  color: var(--text-primary);
  font-size: 1.5rem;
  font-weight: 700;
  margin-bottom: 1rem;
}

/* Grid Layout */
.grid-layout {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 0.75rem;
  width: 100%;
}

.info-column {
  display: flex;
  flex-direction: column;
  gap: 0.625rem;
}

/* Info Items */
.info-item {
  background: var(--bg-secondary);
  padding: 0.75rem 0.875rem;
  border-radius: 8px;
  border-left: 2px solid #1f7c50;
  transition: all 0.2s ease;
}

.info-item:hover {
  background: var(--bg-tertiary);
  transform: translateX(2px);
}

.info-item strong {
  color: var(--text-primary);
  font-weight: 600;
  display: block;
  margin-bottom: 0.125rem;
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.info-item span {
  color: var(--text-secondary);
  font-size: 0.875rem;
}

/* Framework Cards */
.framework-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 0.75rem;
  width: 100%;
}

.framework-card {
  background: var(--bg-primary);
  border-radius: 10px;
  padding: 1rem;
  box-shadow: var(--shadow-sm);
  border: 1px solid var(--border-light);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
}

.framework-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 2px;
  background: var(--gradient-secondary);
}

.framework-card:hover {
  transform: translateY(-2px) scale(1.005);
  box-shadow: var(--shadow-md);
}

.framework-header {
  display: flex;
  align-items: center;
  margin-bottom: 0.75rem;
  gap: 0.75rem;
}

.framework-icon {
  width: 36px;
  height: 36px;
  border-radius: 6px;
  background: var(--bg-tertiary);
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--icon-color);
  font-weight: 600;
  font-size: 1rem;
  border: 1px solid var(--border-light);
}

.framework-header h4 {
  color: var(--text-primary);
  font-weight: 600;
  font-size: 1.5rem;
  margin: 0;
}

.framework-reason {
  color: var(--text-secondary);
  font-size: 1rem;
  line-height: 1.5;
  margin: 0 0 0.75rem 0;
}

.framework-footer {
  border-top: 1px solid var(--border-light);
  padding-top: 0.5rem;
  margin-top: auto;
}

.framework-id {
  color: var(--text-muted);
  font-size: 0.65rem;
  font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
}

/* Controls Section */
.controls-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
  flex-wrap: wrap;
  gap: 0.75rem;
}

.controls-stats {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.controls-count {
  background: var(--bg-secondary);
  color: var(--text-secondary);
  padding: 0.375rem 0.75rem;
  border-radius: 12px;
  font-size: 0.75rem;
  font-weight: 500;
  border: 1px solid var(--border-light);
}

.status-badge {
  padding: 0.375rem 0.75rem;
  border-radius: 16px;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  box-shadow: var(--shadow-sm);
  transition: all 0.2s ease;
}

.status-badge.complete {
  background: #1f7c50;
  color: white;
  box-shadow: 0 2px 6px rgba(31, 124, 80, 0.3);
}

.status-badge.pending {
  background: linear-gradient(135deg, #07ffa9 0%, #1f7c50 100%);
  color: #1e293b;
  box-shadow: 0 2px 6px rgba(7, 255, 169, 0.3);
}

.status-badge:hover {
  transform: scale(1.01);
}

/* Control Groups */
.control-group {
  margin-bottom: 1.25rem;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: var(--shadow-sm);
  background: var(--bg-primary);
}

.group-header {
  background: var(--bg-secondary);
  color: var(--text-primary);
  padding: 0.875rem 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 2px solid var(--border-light);
}

.group-header h4 {
  margin: 0;
  font-weight: 600;
  font-size: 1.25rem;
  color: var(--text-primary);
}

.owner-badge {
  background: var(--bg-tertiary);
  color: var(--text-secondary);
  padding: 0.125rem 0.5rem;
  border-radius: 4px;
  font-size: 0.75rem;
  font-weight: 500;
  border: 1px solid var(--border-light);
}

.group-description {
  background: var(--bg-secondary);
  padding: 0.875rem 1rem;
  border-bottom: 1px solid var(--border-light);
}

.group-description p {
  margin: 0.25rem 0;
  color: var(--text-secondary);
  line-height: 1.4;
  font-size: 0.85rem;
}

/* Table Styling */
.table-container {
  overflow-x: auto;
  border-radius: 0 0 10px 10px;
  width: 100%;
}

.controls-table {
  width: 100%;
  border-collapse: collapse;
  background: var(--bg-primary);
}

.controls-table th {
  background: var(--bg-tertiary);
  color: var(--text-primary);
  text-align: left;
  padding: 0.875rem 0.75rem;
  font-weight: 600;
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  border-bottom: 2px solid var(--border-color);
}

.controls-table td {
  padding: 0.875rem 0.75rem;
  border-bottom: 1px solid var(--border-light);
  vertical-align: top;
  transition: background-color 0.2s ease;
}

.controls-table tr:hover {
  background-color: var(--bg-secondary);
}

.controls-table tr:last-child td {
  border-bottom: none;
}

/* Control Row Styling */
.control-name-container {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.control-icon {
  width: 28px;
  height: 28px;
  background: var(--bg-tertiary);
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--icon-color);
  font-weight: 600;
  font-size: 0.75rem;
  flex-shrink: 0;
  border: 1px solid var(--border-light);
}

.control-code {
  font-weight: 600;
  color: var(--text-primary);
  font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
  font-size: 0.75rem;
}

.control-name {
  font-weight: 500;
  color: var(--text-primary);
}

.control-description {
  color: var(--text-secondary);
  line-height: 1.4;
  max-width: 250px;
  font-size: 0.85rem;
}

.control-owner {
  color: var(--text-secondary);
  font-weight: 500;
  font-size: 0.85rem;
}

/* Type Badges */
.type-badge {
  padding: 0.125rem 0.5rem;
  border-radius: 4px;
  font-size: 0.65rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  box-shadow: var(--shadow-sm);
}

.type-badge.mandatory {
  background: var(--gradient-success);
  color: white;
}

.type-badge.optional {
  background: var(--gradient-warning);
  color: white;
}

/* Services List */
.services-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 0.75rem;
  width: 100%;
}

.service-item {
  background: var(--bg-secondary);
  padding: 0.75rem 0.875rem;
  border-radius: 8px;
  color: var(--text-secondary);
  position: relative;
  padding-left: 2.25rem;
  line-height: 1.4;
  transition: all 0.2s ease;
  border-left: 2px solid var(--secondary-color);
}

.service-item:hover {
  background: var(--bg-tertiary);
  transform: translateX(2px);
}

.service-bullet {
  position: absolute;
  left: 0.75rem;
  top: 50%;
  transform: translateY(-50%);
  width: 8px;
  height: 8px;
  background: var(--secondary-color);
  border-radius: 50%;
  box-shadow: var(--shadow-sm);
}

/* Loading States */
.loading-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 40vh;
  gap: 1rem;
  background: var(--bg-primary);
  border-radius: 12px;
  padding: 2rem;
  box-shadow: var(--shadow-md);
  width: 100%;
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 2px solid rgba(31, 124, 80, 0.2);
  border-top: 2px solid #1f7c50;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  box-shadow: var(--shadow-sm);
}

.loading-container p {
  color: var(--text-secondary);
  font-size: 0.95rem;
  font-weight: 500;
}

/* Loading dots animation */
.loading-dots {
  display: flex;
  gap: 0.25rem;
}

.loading-dots span {
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: #1f7c50;
  animation: dots 1.4s infinite ease-in-out;
}

.loading-dots span:nth-child(1) { animation-delay: -0.32s; }
.loading-dots span:nth-child(2) { animation-delay: -0.16s; }

@keyframes dots {
  0%, 80%, 100% {
    transform: scale(0);
    opacity: 0.5;
  }
  40% {
    transform: scale(1);
    opacity: 1;
  }
}

/* Error States */
.error-container {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1.25rem;
  background: linear-gradient(135deg, #fee2e2 0%, #fecaca 100%);
  border-radius: 10px;
  margin: 0.75rem 0;
  color: var(--error-color);
  border-left: 2px solid var(--error-color);
  box-shadow: var(--shadow-sm);
  width: 100%;
}

.error-icon {
  width: 36px;
  height: 36px;
  background: var(--error-color);
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 1rem;
  box-shadow: var(--shadow-sm);
}

.error-content {
  flex: 1 1;
}

.error-title {
  font-size: 1rem;
  font-weight: 600;
  margin-bottom: 0.25rem;
}

.error-message {
  font-weight: 500;
  font-size: 0.9rem;
  margin-bottom: 0.75rem;
}

/* Buttons */
.retry-button,
.refresh-button {
  background: var(--gradient-secondary);
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 6px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: var(--shadow-sm);
  font-size: 0.85rem;
}

.retry-button:hover,
.refresh-button:hover {
  transform: translateY(-1px);
  box-shadow: var(--shadow-sm);
}

/* Empty States */
.empty-state {
  padding: 2rem 1.25rem;
  text-align: center;
  color: var(--text-muted);
  background: var(--bg-secondary);
  border-radius: 10px;
  border: 2px dashed var(--border-color);
  width: 100%;
}

.empty-icon {
  font-size: 2rem;
  margin-bottom: 0.75rem;
  opacity: 0.5;
}

.empty-state h3 {
  color: var(--text-primary);
  font-size: 1.125rem;
  font-weight: 600;
  margin-bottom: 0.25rem;
}

.empty-state p {
  font-size: 0.95rem;
  font-weight: 500;
  margin: 0 0 1rem 0;
}

/* Dashboard Footer */
.dashboard-footer {
  background: var(--bg-primary);
  border-radius: 10px;
  padding: 1rem 1.25rem;
  margin-top: 1rem;
  text-align: center;
  color: var(--text-muted);
  font-size: 0.75rem;
  box-shadow: var(--shadow-sm);
  border: 1px solid var(--border-light);
  width: 100%;
}

.dashboard-footer p {
  margin: 0.125rem 0;
}

.footer-actions {
  margin-top: 1rem;
  display: flex;
  justify-content: center;
  gap: 1rem;
}

.assessment-link {
  padding: 0.75rem 1.5rem;
  background: #1f7c50;
  color: white;
  border: none;
  border-radius: var(--border-radius);
  font-weight: 600;
  cursor: pointer;
  transition: var(--transition);
  font-size: 0.875rem;
  text-decoration: none;
  display: inline-block;
  box-shadow: 0 2px 8px rgba(31, 124, 80, 0.35);
}

.assessment-link:hover {
  background: #1a6b45;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(31, 124, 80, 0.4);
}

/* Submit / primary buttons in this page - Qatar #1f7c50 */
.root button[type="submit"],
.root .btn-primary,
.root .btn-submit {
  background-color: #1f7c50 !important;
  border-color: #1f7c50 !important;
}
.root button[type="submit"]:hover:not(:disabled),
.root .btn-primary:hover:not(:disabled),
.root .btn-submit:hover:not(:disabled) {
  background-color: #1a6b45 !important;
  border-color: #1a6b45 !important;
}

/* Animations */
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateX(-10px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

/* Apply animations to cards */
.info-card {
  animation: fadeIn 0.4s ease-out;
}

.framework-card {
  animation: slideIn 0.4s ease-out;
}

/* Responsive Design */
@media (max-width: 768px) {
  .root {
    padding: 0.25rem;
    margin-top: 100px;
  }
  
  .dashboard-header {
    padding: 1rem;
  }
  
  .header-content {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .dashboard-title {
    font-size: 1.25rem;
  }
  
  .tab-navigation {
    width: 100%;
    justify-content: center;
  }
  
  .info-card {
    padding: 1rem;
    margin-bottom: 1rem;
  }
  
  .grid-layout {
    grid-template-columns: 1fr;
    gap: 0.625rem;
  }
  
  .framework-grid {
    grid-template-columns: 1fr;
    gap: 0.625rem;
  }
  
  .services-list {
    grid-template-columns: 1fr;
  }
  
  .controls-header {
    flex-direction: column;
    gap: 0.75rem;
    align-items: flex-start;
  }
  
  .controls-stats {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .org-name {
    font-size: 1.25rem;
  }
  
  .section-title {
    font-size: 1rem;
  }
}

@media (max-width: 480px) {
  .root {
    padding: 0.125rem;
  }
  
  .dashboard-header {
    padding: 0.75rem;
  }
  
  .info-card {
    padding: 0.75rem;
    border-radius: 8px;
  }
  
  .framework-card {
    padding: 0.75rem;
  }
  
  .controls-table th,
  .controls-table td {
    padding: 0.5rem 0.375rem;
    font-size: 0.75rem;
  }
  
  .tab-button {
    padding: 0.375rem 0.75rem;
    font-size: 0.75rem;
  }
}

/* Dark mode support */
@media (prefers-color-scheme: dark) {
  :root {
    --bg-primary: #1f2937;
    --bg-secondary: #111827;
    --bg-tertiary: #374151;
    --text-primary: #f9fafb;
    --text-secondary: #d1d5db;
    --text-muted: #9ca3af;
    --icon-color: #9ca3af;
    --border-color: #374151;
    --border-light: #4b5563;
  }
  
  body {
    background: linear-gradient(135deg, #1f2937 0%, #111827 100%);
  }
}

/* Custom scrollbar */
.table-container::-webkit-scrollbar {
  height: 4px;
}

.table-container::-webkit-scrollbar-track {
  background: var(--bg-tertiary);
  border-radius: 2px;
}

.table-container::-webkit-scrollbar-thumb {
  background: var(--secondary-color);
  border-radius: 2px;
}

.table-container::-webkit-scrollbar-thumb:hover {
  background: var(--accent-color);
}
    `, "",{"version":3,"sources":["webpack://./src/pages/frameWork/style.css"],"names":[],"mappings":"AAAA,2DAA2D;;AAE3D,8CAA8C;;AAG9C,iEAAiE;AACjE;EACE,wBAAwB;EACxB,wBAAwB;EACxB,uBAAuB;EACvB,0BAA0B;EAC1B,uBAAuB;EACvB,wBAAwB;EACxB,wBAAwB;EACxB,sBAAsB;EACtB,uBAAuB;EACvB,yBAAyB;EACzB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,uBAAuB;EACvB,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,4CAA4C;EAC5C,kFAAkF;EAClF,oFAAoF;EACpF,sFAAsF;EACtF,oGAAoG;EACpG,uEAAuE;EACvE,qEAAqE;EACrE,qEAAqE;EACrE,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA,kBAAkB;AAClB;EACE,sBAAsB;AACxB;;AAEA;EACE,uFAAuF;EACvF,gBAAgB;EAChB,0BAA0B;EAC1B,6DAA6D;EAC7D,iBAAiB;EACjB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA,qBAAqB;AACrB;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,4BAA4B;EAC5B,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,oDAAoD;AACtD;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,iDAAiD;AACnD;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,+BAA+B;EAC/B,iBAAiB;EACjB,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,uBAAuB;EACvB,4BAA4B;EAC5B,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;EAC1B,8BAA8B;AAChC;;AAEA;EACE,gCAAgC;EAChC,YAAY;EACZ,6CAA6C;AAC/C;;AAEA,0BAA0B;AAC1B;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,4BAA4B;EAC5B,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,iDAAiD;EACjD,WAAW;AACb;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,qCAAqC;AACvC;;AAEA;EACE,2BAA2B;EAC3B,gDAAgD;AAClD;;AAEA,iDAAiD;AACjD;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,iDAAiD;AACnD;;AAEA,iBAAiB;AACjB;;EAEE,+BAA+B;EAC/B,4BAA4B;EAC5B,wBAAwB;EACxB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,qCAAqC;AACvC;;AAEA,sBAAsB;AACtB;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,2DAA2D;EAC3D,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA,eAAe;AACf;EACE,+BAA+B;EAC/B,yBAAyB;EACzB,kBAAkB;EAClB,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,4DAA4D;EAC5D,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,aAAa;EACb,4BAA4B;EAC5B,qCAAqC;EACrC,iDAAiD;EACjD,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,qCAAqC;AACvC;;AAEA;EACE,wCAAwC;EACxC,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,wBAAwB;EACxB,gBAAgB;EAChB,eAAe;EACf,qCAAqC;AACvC;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,yCAAyC;EACzC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,wDAAwD;AAC1D;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,+BAA+B;EAC/B,4BAA4B;EAC5B,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,4CAA4C;AAC9C;;AAEA;EACE,6DAA6D;EAC7D,cAAc;EACd,4CAA4C;AAC9C;;AAEA;EACE,sBAAsB;AACxB;;AAEA,mBAAmB;AACnB;EACE,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B;EAC/B,0BAA0B;EAC1B,sBAAsB;EACtB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,8BAA8B;EAC9B,4BAA4B;EAC5B,wBAAwB;EACxB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,+BAA+B;EAC/B,sBAAsB;EACtB,4CAA4C;AAC9C;;AAEA;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,kBAAkB;AAClB;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,WAAW;AACb;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;EAC9B,0BAA0B;EAC1B,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,4CAA4C;AAC9C;;AAEA;EACE,yBAAyB;EACzB,4CAA4C;EAC5C,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;AACrB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,wBAAwB;EACxB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,wDAAwD;EACxD,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,gBAAgB;AAChB;EACE,wBAAwB;EACxB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,mCAAmC;EACnC,YAAY;AACd;;AAEA;EACE,mCAAmC;EACnC,YAAY;AACd;;AAEA,kBAAkB;AAClB;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,aAAa;EACb,2DAA2D;EAC3D,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,+BAA+B;EAC/B,yBAAyB;EACzB,kBAAkB;EAClB,4BAA4B;EAC5B,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;EAChB,yBAAyB;EACzB,6CAA6C;AAC/C;;AAEA;EACE,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,QAAQ;EACR,2BAA2B;EAC3B,UAAU;EACV,WAAW;EACX,kCAAkC;EAClC,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,SAAS;EACT,6BAA6B;EAC7B,mBAAmB;EACnB,aAAa;EACb,4BAA4B;EAC5B,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,wCAAwC;EACxC,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;EAClC,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA,kCAAkC,uBAAuB,EAAE;AAC3D,kCAAkC,uBAAuB,EAAE;;AAE3D;EACE;IACE,mBAAmB;IACnB,YAAY;EACd;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,6DAA6D;EAC7D,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;EACzB,yCAAyC;EACzC,4BAA4B;EAC5B,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA,YAAY;AACZ;;EAEE,qCAAqC;EACrC,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;;EAEE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA,iBAAiB;AACjB;EACE,qBAAqB;EACrB,kBAAkB;EAClB,wBAAwB;EACxB,+BAA+B;EAC/B,mBAAmB;EACnB,sCAAsC;EACtC,WAAW;AACb;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,qBAAqB;AACrB;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,wBAAwB;EACxB,kBAAkB;EAClB,4BAA4B;EAC5B,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,mCAAmC;EACnC,gBAAgB;EAChB,eAAe;EACf,6BAA6B;EAC7B,mBAAmB;EACnB,qBAAqB;EACrB,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA,0DAA0D;AAC1D;;;EAGE,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;;EAGE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA,eAAe;AACf;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,8BAA8B;AAC9B;EACE,+BAA+B;AACjC;;AAEA;EACE,gCAAgC;AAClC;;AAEA,sBAAsB;AACtB;EACE;IACE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;IAC1B,aAAa;EACf;;EAEA;IACE,0BAA0B;IAC1B,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,YAAY;IACZ,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;;IAEE,wBAAwB;IACxB,kBAAkB;EACpB;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;EACpB;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,qBAAqB;IACrB,uBAAuB;IACvB,sBAAsB;IACtB,uBAAuB;IACvB,yBAAyB;IACzB,qBAAqB;IACrB,qBAAqB;IACrB,uBAAuB;IACvB,uBAAuB;EACzB;;EAEA;IACE,6DAA6D;EAC/D;AACF;;AAEA,qBAAqB;AACrB;EACE,WAAW;AACb;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;AACjC","sourcesContent":["/* Modern Beautiful Design for User Information Dashboard */\r\n\r\n/* Import Google Fonts for better typography */\r\n@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap');\r\n\r\n/* CSS Variables - Qatar theme (1f7c50, 07ffa9, 101413, accbc3) */\r\n:root {\r\n  --primary-color: #accbc3;\r\n  --primary-light: #e5f6f2;\r\n  --primary-dark: #7b9f96;\r\n  --secondary-color: #1f7c50;\r\n  --accent-color: #07ffa9;\r\n  --success-color: #07ffa9;\r\n  --warning-color: #1f7c50;\r\n  --error-color: #ef4444;\r\n  --text-primary: #1e293b;\r\n  --text-secondary: #475569;\r\n  --text-muted: #64748b;\r\n  --icon-color: #64748b;\r\n  --bg-primary: #ffffff;\r\n  --bg-secondary: #f8fafc;\r\n  --bg-tertiary: #f1f5f9;\r\n  --border-color: #e2e8f0;\r\n  --border-light: #f1f5f9;\r\n  --shadow-sm: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\r\n  --shadow-md: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);\r\n  --shadow-lg: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);\r\n  --shadow-xl: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);\r\n  --gradient-primary: linear-gradient(135deg, rgba(7, 255, 169, 0.15) 0%, rgba(31, 124, 80, 0.2) 100%);\r\n  --gradient-secondary: linear-gradient(135deg, #07ffa9 0%, #1f7c50 100%);\r\n  --gradient-success: linear-gradient(135deg, #07ffa9 0%, #1f7c50 100%);\r\n  --gradient-warning: linear-gradient(135deg, #1f7c50 0%, #1a6b45 100%);\r\n  --btn-submit-bg: #1f7c50;\r\n  --btn-submit-hover: #1a6b45;\r\n}\r\n\r\n/* Global Styles */\r\n* {\r\n  box-sizing: border-box;\r\n}\r\n\r\nbody {\r\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\r\n  line-height: 1.6;\r\n  color: var(--text-primary);\r\n  background: linear-gradient(135deg, #e2e8f0 0%, #cbd5e1 100%);\r\n  min-height: 100vh;\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n\r\n.root {\r\n  margin-top: 130px;\r\n  padding: 0.5rem;\r\n  width: 100%;\r\n  max-width: 100%;\r\n  margin-left: 0;\r\n  margin-right: 0;\r\n}\r\n\r\n/* Dashboard Header */\r\n.dashboard-header {\r\n  background: var(--bg-primary);\r\n  border-radius: 12px;\r\n  padding: 1.25rem;\r\n  margin-bottom: 1rem;\r\n  box-shadow: var(--shadow-md);\r\n  border: 1px solid var(--border-light);\r\n  position: relative;\r\n  overflow: hidden;\r\n  width: 100%;\r\n}\r\n\r\n.dashboard-header::before {\r\n  content: '';\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  height: 2px;\r\n  background: linear-gradient(90deg, #07ffa9, #1f7c50);\r\n}\r\n\r\n.header-content {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  flex-wrap: wrap;\r\n  gap: 0.75rem;\r\n  width: 100%;\r\n}\r\n\r\n.dashboard-title {\r\n  color: #1f7c50;\r\n  font-size: 1.5rem;\r\n  font-weight: 700;\r\n  margin: 0;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.75rem;\r\n}\r\n\r\n.title-icon {\r\n  font-size: 1.75rem;\r\n  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));\r\n}\r\n\r\n.tab-navigation {\r\n  display: flex;\r\n  gap: 0.25rem;\r\n  background: var(--bg-secondary);\r\n  padding: 0.375rem;\r\n  border-radius: 10px;\r\n  box-shadow: var(--shadow-sm);\r\n}\r\n\r\n.tab-button {\r\n  padding: 0.625rem 1.25rem;\r\n  border: none;\r\n  background: transparent;\r\n  color: var(--text-secondary);\r\n  font-weight: 500;\r\n  border-radius: 6px;\r\n  cursor: pointer;\r\n  transition: all 0.2s ease;\r\n  font-size: 0.8rem;\r\n}\r\n\r\n.tab-button:hover {\r\n  color: var(--text-primary);\r\n  background: var(--bg-tertiary);\r\n}\r\n\r\n.tab-button.active {\r\n  background: var(--btn-submit-bg);\r\n  color: white;\r\n  box-shadow: 0 2px 8px rgba(31, 124, 80, 0.35);\r\n}\r\n\r\n/* Beautiful Card Design */\r\n.info-card {\r\n  background: var(--bg-primary);\r\n  border-radius: 12px;\r\n  padding: 1.25rem;\r\n  margin-bottom: 1rem;\r\n  box-shadow: var(--shadow-md);\r\n  border: 1px solid var(--border-light);\r\n  position: relative;\r\n  overflow: hidden;\r\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\r\n  width: 100%;\r\n}\r\n\r\n.info-card::before {\r\n  content: '';\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  height: 2px;\r\n  background: var(--gradient-secondary);\r\n}\r\n\r\n.info-card:hover {\r\n  transform: translateY(-1px);\r\n  box-shadow: 0 15px 30px -10px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n/* Section Titles with Beautiful Design - Qatar */\r\n.section-title {\r\n  color: #1f7c50;\r\n  font-size: 1.5rem;\r\n  font-weight: 600;\r\n  margin-bottom: 1rem;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.625rem;\r\n  position: relative;\r\n  padding-bottom: 0.5rem;\r\n}\r\n\r\n.section-title::after {\r\n  content: '';\r\n  position: absolute;\r\n  bottom: 0;\r\n  left: 0;\r\n  width: 40px;\r\n  height: 2px;\r\n  background: #1f7c50;\r\n  border-radius: 1px;\r\n}\r\n\r\n.section-icon {\r\n  font-size: 1.25rem;\r\n  color: var(--icon-color);\r\n  filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.1));\r\n}\r\n\r\n/* Count badges */\r\n.framework-count,\r\n.services-count {\r\n  background: var(--bg-secondary);\r\n  color: var(--text-secondary);\r\n  padding: 0.125rem 0.5rem;\r\n  border-radius: 8px;\r\n  font-size: 0.7rem;\r\n  font-weight: 600;\r\n  margin-left: 0.375rem;\r\n  border: 1px solid var(--border-light);\r\n}\r\n\r\n/* Organization Name */\r\n.org-name {\r\n  color: var(--text-primary);\r\n  font-size: 1.5rem;\r\n  font-weight: 700;\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n/* Grid Layout */\r\n.grid-layout {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\r\n  gap: 0.75rem;\r\n  width: 100%;\r\n}\r\n\r\n.info-column {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.625rem;\r\n}\r\n\r\n/* Info Items */\r\n.info-item {\r\n  background: var(--bg-secondary);\r\n  padding: 0.75rem 0.875rem;\r\n  border-radius: 8px;\r\n  border-left: 2px solid #1f7c50;\r\n  transition: all 0.2s ease;\r\n}\r\n\r\n.info-item:hover {\r\n  background: var(--bg-tertiary);\r\n  transform: translateX(2px);\r\n}\r\n\r\n.info-item strong {\r\n  color: var(--text-primary);\r\n  font-weight: 600;\r\n  display: block;\r\n  margin-bottom: 0.125rem;\r\n  font-size: 0.75rem;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.05em;\r\n}\r\n\r\n.info-item span {\r\n  color: var(--text-secondary);\r\n  font-size: 0.875rem;\r\n}\r\n\r\n/* Framework Cards */\r\n.framework-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));\r\n  gap: 0.75rem;\r\n  width: 100%;\r\n}\r\n\r\n.framework-card {\r\n  background: var(--bg-primary);\r\n  border-radius: 10px;\r\n  padding: 1rem;\r\n  box-shadow: var(--shadow-sm);\r\n  border: 1px solid var(--border-light);\r\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\r\n  position: relative;\r\n  overflow: hidden;\r\n}\r\n\r\n.framework-card::before {\r\n  content: '';\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  height: 2px;\r\n  background: var(--gradient-secondary);\r\n}\r\n\r\n.framework-card:hover {\r\n  transform: translateY(-2px) scale(1.005);\r\n  box-shadow: var(--shadow-md);\r\n}\r\n\r\n.framework-header {\r\n  display: flex;\r\n  align-items: center;\r\n  margin-bottom: 0.75rem;\r\n  gap: 0.75rem;\r\n}\r\n\r\n.framework-icon {\r\n  width: 36px;\r\n  height: 36px;\r\n  border-radius: 6px;\r\n  background: var(--bg-tertiary);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  color: var(--icon-color);\r\n  font-weight: 600;\r\n  font-size: 1rem;\r\n  border: 1px solid var(--border-light);\r\n}\r\n\r\n.framework-header h4 {\r\n  color: var(--text-primary);\r\n  font-weight: 600;\r\n  font-size: 1.5rem;\r\n  margin: 0;\r\n}\r\n\r\n.framework-reason {\r\n  color: var(--text-secondary);\r\n  font-size: 1rem;\r\n  line-height: 1.5;\r\n  margin: 0 0 0.75rem 0;\r\n}\r\n\r\n.framework-footer {\r\n  border-top: 1px solid var(--border-light);\r\n  padding-top: 0.5rem;\r\n  margin-top: auto;\r\n}\r\n\r\n.framework-id {\r\n  color: var(--text-muted);\r\n  font-size: 0.65rem;\r\n  font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;\r\n}\r\n\r\n/* Controls Section */\r\n.controls-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin-bottom: 1rem;\r\n  flex-wrap: wrap;\r\n  gap: 0.75rem;\r\n}\r\n\r\n.controls-stats {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.75rem;\r\n}\r\n\r\n.controls-count {\r\n  background: var(--bg-secondary);\r\n  color: var(--text-secondary);\r\n  padding: 0.375rem 0.75rem;\r\n  border-radius: 12px;\r\n  font-size: 0.75rem;\r\n  font-weight: 500;\r\n  border: 1px solid var(--border-light);\r\n}\r\n\r\n.status-badge {\r\n  padding: 0.375rem 0.75rem;\r\n  border-radius: 16px;\r\n  font-size: 0.75rem;\r\n  font-weight: 600;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.05em;\r\n  box-shadow: var(--shadow-sm);\r\n  transition: all 0.2s ease;\r\n}\r\n\r\n.status-badge.complete {\r\n  background: #1f7c50;\r\n  color: white;\r\n  box-shadow: 0 2px 6px rgba(31, 124, 80, 0.3);\r\n}\r\n\r\n.status-badge.pending {\r\n  background: linear-gradient(135deg, #07ffa9 0%, #1f7c50 100%);\r\n  color: #1e293b;\r\n  box-shadow: 0 2px 6px rgba(7, 255, 169, 0.3);\r\n}\r\n\r\n.status-badge:hover {\r\n  transform: scale(1.01);\r\n}\r\n\r\n/* Control Groups */\r\n.control-group {\r\n  margin-bottom: 1.25rem;\r\n  border-radius: 10px;\r\n  overflow: hidden;\r\n  box-shadow: var(--shadow-sm);\r\n  background: var(--bg-primary);\r\n}\r\n\r\n.group-header {\r\n  background: var(--bg-secondary);\r\n  color: var(--text-primary);\r\n  padding: 0.875rem 1rem;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  border-bottom: 2px solid var(--border-light);\r\n}\r\n\r\n.group-header h4 {\r\n  margin: 0;\r\n  font-weight: 600;\r\n  font-size: 1.25rem;\r\n  color: var(--text-primary);\r\n}\r\n\r\n.owner-badge {\r\n  background: var(--bg-tertiary);\r\n  color: var(--text-secondary);\r\n  padding: 0.125rem 0.5rem;\r\n  border-radius: 4px;\r\n  font-size: 0.75rem;\r\n  font-weight: 500;\r\n  border: 1px solid var(--border-light);\r\n}\r\n\r\n.group-description {\r\n  background: var(--bg-secondary);\r\n  padding: 0.875rem 1rem;\r\n  border-bottom: 1px solid var(--border-light);\r\n}\r\n\r\n.group-description p {\r\n  margin: 0.25rem 0;\r\n  color: var(--text-secondary);\r\n  line-height: 1.4;\r\n  font-size: 0.85rem;\r\n}\r\n\r\n/* Table Styling */\r\n.table-container {\r\n  overflow-x: auto;\r\n  border-radius: 0 0 10px 10px;\r\n  width: 100%;\r\n}\r\n\r\n.controls-table {\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n  background: var(--bg-primary);\r\n}\r\n\r\n.controls-table th {\r\n  background: var(--bg-tertiary);\r\n  color: var(--text-primary);\r\n  text-align: left;\r\n  padding: 0.875rem 0.75rem;\r\n  font-weight: 600;\r\n  font-size: 0.75rem;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.05em;\r\n  border-bottom: 2px solid var(--border-color);\r\n}\r\n\r\n.controls-table td {\r\n  padding: 0.875rem 0.75rem;\r\n  border-bottom: 1px solid var(--border-light);\r\n  vertical-align: top;\r\n  transition: background-color 0.2s ease;\r\n}\r\n\r\n.controls-table tr:hover {\r\n  background-color: var(--bg-secondary);\r\n}\r\n\r\n.controls-table tr:last-child td {\r\n  border-bottom: none;\r\n}\r\n\r\n/* Control Row Styling */\r\n.control-name-container {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.5rem;\r\n}\r\n\r\n.control-icon {\r\n  width: 28px;\r\n  height: 28px;\r\n  background: var(--bg-tertiary);\r\n  border-radius: 4px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  color: var(--icon-color);\r\n  font-weight: 600;\r\n  font-size: 0.75rem;\r\n  flex-shrink: 0;\r\n  border: 1px solid var(--border-light);\r\n}\r\n\r\n.control-code {\r\n  font-weight: 600;\r\n  color: var(--text-primary);\r\n  font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;\r\n  font-size: 0.75rem;\r\n}\r\n\r\n.control-name {\r\n  font-weight: 500;\r\n  color: var(--text-primary);\r\n}\r\n\r\n.control-description {\r\n  color: var(--text-secondary);\r\n  line-height: 1.4;\r\n  max-width: 250px;\r\n  font-size: 0.85rem;\r\n}\r\n\r\n.control-owner {\r\n  color: var(--text-secondary);\r\n  font-weight: 500;\r\n  font-size: 0.85rem;\r\n}\r\n\r\n/* Type Badges */\r\n.type-badge {\r\n  padding: 0.125rem 0.5rem;\r\n  border-radius: 4px;\r\n  font-size: 0.65rem;\r\n  font-weight: 600;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.05em;\r\n  box-shadow: var(--shadow-sm);\r\n}\r\n\r\n.type-badge.mandatory {\r\n  background: var(--gradient-success);\r\n  color: white;\r\n}\r\n\r\n.type-badge.optional {\r\n  background: var(--gradient-warning);\r\n  color: white;\r\n}\r\n\r\n/* Services List */\r\n.services-list {\r\n  list-style: none;\r\n  padding: 0;\r\n  margin: 0;\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\r\n  gap: 0.75rem;\r\n  width: 100%;\r\n}\r\n\r\n.service-item {\r\n  background: var(--bg-secondary);\r\n  padding: 0.75rem 0.875rem;\r\n  border-radius: 8px;\r\n  color: var(--text-secondary);\r\n  position: relative;\r\n  padding-left: 2.25rem;\r\n  line-height: 1.4;\r\n  transition: all 0.2s ease;\r\n  border-left: 2px solid var(--secondary-color);\r\n}\r\n\r\n.service-item:hover {\r\n  background: var(--bg-tertiary);\r\n  transform: translateX(2px);\r\n}\r\n\r\n.service-bullet {\r\n  position: absolute;\r\n  left: 0.75rem;\r\n  top: 50%;\r\n  transform: translateY(-50%);\r\n  width: 8px;\r\n  height: 8px;\r\n  background: var(--secondary-color);\r\n  border-radius: 50%;\r\n  box-shadow: var(--shadow-sm);\r\n}\r\n\r\n/* Loading States */\r\n.loading-container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  align-items: center;\r\n  min-height: 40vh;\r\n  gap: 1rem;\r\n  background: var(--bg-primary);\r\n  border-radius: 12px;\r\n  padding: 2rem;\r\n  box-shadow: var(--shadow-md);\r\n  width: 100%;\r\n}\r\n\r\n.loading-spinner {\r\n  width: 40px;\r\n  height: 40px;\r\n  border: 2px solid rgba(31, 124, 80, 0.2);\r\n  border-top: 2px solid #1f7c50;\r\n  border-radius: 50%;\r\n  animation: spin 1s linear infinite;\r\n  box-shadow: var(--shadow-sm);\r\n}\r\n\r\n.loading-container p {\r\n  color: var(--text-secondary);\r\n  font-size: 0.95rem;\r\n  font-weight: 500;\r\n}\r\n\r\n/* Loading dots animation */\r\n.loading-dots {\r\n  display: flex;\r\n  gap: 0.25rem;\r\n}\r\n\r\n.loading-dots span {\r\n  width: 5px;\r\n  height: 5px;\r\n  border-radius: 50%;\r\n  background: #1f7c50;\r\n  animation: dots 1.4s infinite ease-in-out;\r\n}\r\n\r\n.loading-dots span:nth-child(1) { animation-delay: -0.32s; }\r\n.loading-dots span:nth-child(2) { animation-delay: -0.16s; }\r\n\r\n@keyframes dots {\r\n  0%, 80%, 100% {\r\n    transform: scale(0);\r\n    opacity: 0.5;\r\n  }\r\n  40% {\r\n    transform: scale(1);\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n/* Error States */\r\n.error-container {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 1rem;\r\n  padding: 1.25rem;\r\n  background: linear-gradient(135deg, #fee2e2 0%, #fecaca 100%);\r\n  border-radius: 10px;\r\n  margin: 0.75rem 0;\r\n  color: var(--error-color);\r\n  border-left: 2px solid var(--error-color);\r\n  box-shadow: var(--shadow-sm);\r\n  width: 100%;\r\n}\r\n\r\n.error-icon {\r\n  width: 36px;\r\n  height: 36px;\r\n  background: var(--error-color);\r\n  color: white;\r\n  border-radius: 50%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-weight: bold;\r\n  font-size: 1rem;\r\n  box-shadow: var(--shadow-sm);\r\n}\r\n\r\n.error-content {\r\n  flex: 1;\r\n}\r\n\r\n.error-title {\r\n  font-size: 1rem;\r\n  font-weight: 600;\r\n  margin-bottom: 0.25rem;\r\n}\r\n\r\n.error-message {\r\n  font-weight: 500;\r\n  font-size: 0.9rem;\r\n  margin-bottom: 0.75rem;\r\n}\r\n\r\n/* Buttons */\r\n.retry-button,\r\n.refresh-button {\r\n  background: var(--gradient-secondary);\r\n  color: white;\r\n  border: none;\r\n  padding: 0.5rem 1rem;\r\n  border-radius: 6px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: all 0.2s ease;\r\n  box-shadow: var(--shadow-sm);\r\n  font-size: 0.85rem;\r\n}\r\n\r\n.retry-button:hover,\r\n.refresh-button:hover {\r\n  transform: translateY(-1px);\r\n  box-shadow: var(--shadow-sm);\r\n}\r\n\r\n/* Empty States */\r\n.empty-state {\r\n  padding: 2rem 1.25rem;\r\n  text-align: center;\r\n  color: var(--text-muted);\r\n  background: var(--bg-secondary);\r\n  border-radius: 10px;\r\n  border: 2px dashed var(--border-color);\r\n  width: 100%;\r\n}\r\n\r\n.empty-icon {\r\n  font-size: 2rem;\r\n  margin-bottom: 0.75rem;\r\n  opacity: 0.5;\r\n}\r\n\r\n.empty-state h3 {\r\n  color: var(--text-primary);\r\n  font-size: 1.125rem;\r\n  font-weight: 600;\r\n  margin-bottom: 0.25rem;\r\n}\r\n\r\n.empty-state p {\r\n  font-size: 0.95rem;\r\n  font-weight: 500;\r\n  margin: 0 0 1rem 0;\r\n}\r\n\r\n/* Dashboard Footer */\r\n.dashboard-footer {\r\n  background: var(--bg-primary);\r\n  border-radius: 10px;\r\n  padding: 1rem 1.25rem;\r\n  margin-top: 1rem;\r\n  text-align: center;\r\n  color: var(--text-muted);\r\n  font-size: 0.75rem;\r\n  box-shadow: var(--shadow-sm);\r\n  border: 1px solid var(--border-light);\r\n  width: 100%;\r\n}\r\n\r\n.dashboard-footer p {\r\n  margin: 0.125rem 0;\r\n}\r\n\r\n.footer-actions {\r\n  margin-top: 1rem;\r\n  display: flex;\r\n  justify-content: center;\r\n  gap: 1rem;\r\n}\r\n\r\n.assessment-link {\r\n  padding: 0.75rem 1.5rem;\r\n  background: #1f7c50;\r\n  color: white;\r\n  border: none;\r\n  border-radius: var(--border-radius);\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: var(--transition);\r\n  font-size: 0.875rem;\r\n  text-decoration: none;\r\n  display: inline-block;\r\n  box-shadow: 0 2px 8px rgba(31, 124, 80, 0.35);\r\n}\r\n\r\n.assessment-link:hover {\r\n  background: #1a6b45;\r\n  transform: translateY(-2px);\r\n  box-shadow: 0 4px 12px rgba(31, 124, 80, 0.4);\r\n}\r\n\r\n/* Submit / primary buttons in this page - Qatar #1f7c50 */\r\n.root button[type=\"submit\"],\r\n.root .btn-primary,\r\n.root .btn-submit {\r\n  background-color: #1f7c50 !important;\r\n  border-color: #1f7c50 !important;\r\n}\r\n.root button[type=\"submit\"]:hover:not(:disabled),\r\n.root .btn-primary:hover:not(:disabled),\r\n.root .btn-submit:hover:not(:disabled) {\r\n  background-color: #1a6b45 !important;\r\n  border-color: #1a6b45 !important;\r\n}\r\n\r\n/* Animations */\r\n@keyframes spin {\r\n  0% { transform: rotate(0deg); }\r\n  100% { transform: rotate(360deg); }\r\n}\r\n\r\n@keyframes fadeIn {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateY(10px);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: translateY(0);\r\n  }\r\n}\r\n\r\n@keyframes slideIn {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateX(-10px);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: translateX(0);\r\n  }\r\n}\r\n\r\n/* Apply animations to cards */\r\n.info-card {\r\n  animation: fadeIn 0.4s ease-out;\r\n}\r\n\r\n.framework-card {\r\n  animation: slideIn 0.4s ease-out;\r\n}\r\n\r\n/* Responsive Design */\r\n@media (max-width: 768px) {\r\n  .root {\r\n    padding: 0.25rem;\r\n    margin-top: 100px;\r\n  }\r\n  \r\n  .dashboard-header {\r\n    padding: 1rem;\r\n  }\r\n  \r\n  .header-content {\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n  }\r\n  \r\n  .dashboard-title {\r\n    font-size: 1.25rem;\r\n  }\r\n  \r\n  .tab-navigation {\r\n    width: 100%;\r\n    justify-content: center;\r\n  }\r\n  \r\n  .info-card {\r\n    padding: 1rem;\r\n    margin-bottom: 1rem;\r\n  }\r\n  \r\n  .grid-layout {\r\n    grid-template-columns: 1fr;\r\n    gap: 0.625rem;\r\n  }\r\n  \r\n  .framework-grid {\r\n    grid-template-columns: 1fr;\r\n    gap: 0.625rem;\r\n  }\r\n  \r\n  .services-list {\r\n    grid-template-columns: 1fr;\r\n  }\r\n  \r\n  .controls-header {\r\n    flex-direction: column;\r\n    gap: 0.75rem;\r\n    align-items: flex-start;\r\n  }\r\n  \r\n  .controls-stats {\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n  }\r\n  \r\n  .org-name {\r\n    font-size: 1.25rem;\r\n  }\r\n  \r\n  .section-title {\r\n    font-size: 1rem;\r\n  }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n  .root {\r\n    padding: 0.125rem;\r\n  }\r\n  \r\n  .dashboard-header {\r\n    padding: 0.75rem;\r\n  }\r\n  \r\n  .info-card {\r\n    padding: 0.75rem;\r\n    border-radius: 8px;\r\n  }\r\n  \r\n  .framework-card {\r\n    padding: 0.75rem;\r\n  }\r\n  \r\n  .controls-table th,\r\n  .controls-table td {\r\n    padding: 0.5rem 0.375rem;\r\n    font-size: 0.75rem;\r\n  }\r\n  \r\n  .tab-button {\r\n    padding: 0.375rem 0.75rem;\r\n    font-size: 0.75rem;\r\n  }\r\n}\r\n\r\n/* Dark mode support */\r\n@media (prefers-color-scheme: dark) {\r\n  :root {\r\n    --bg-primary: #1f2937;\r\n    --bg-secondary: #111827;\r\n    --bg-tertiary: #374151;\r\n    --text-primary: #f9fafb;\r\n    --text-secondary: #d1d5db;\r\n    --text-muted: #9ca3af;\r\n    --icon-color: #9ca3af;\r\n    --border-color: #374151;\r\n    --border-light: #4b5563;\r\n  }\r\n  \r\n  body {\r\n    background: linear-gradient(135deg, #1f2937 0%, #111827 100%);\r\n  }\r\n}\r\n\r\n/* Custom scrollbar */\r\n.table-container::-webkit-scrollbar {\r\n  height: 4px;\r\n}\r\n\r\n.table-container::-webkit-scrollbar-track {\r\n  background: var(--bg-tertiary);\r\n  border-radius: 2px;\r\n}\r\n\r\n.table-container::-webkit-scrollbar-thumb {\r\n  background: var(--secondary-color);\r\n  border-radius: 2px;\r\n}\r\n\r\n.table-container::-webkit-scrollbar-thumb:hover {\r\n  background: var(--accent-color);\r\n}\r\n    "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
